export const FETCH_MOST = 'FETCH_MOST'
export const LOADING = 'LOADING'
export const FETCH_FAILED = 'FETCH_FAILED'
export const FETCH_SELLERS = 'FETCH_SELLERS'
export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const SEARCH_PRODUCT = 'SEARCH_PRODUCT'
export const REMOVE_ALERT = 'REMOVE_ALERT'
